import script from "./jpReportIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./jpReportIndex.vue?vue&type=script&lang=ts&setup=true"

import "./jpReportIndex.vue?vue&type=style&index=0&id=bb8afa1c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb8afa1c"]])

export default __exports__